import React, { useEffect } from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDelete from '../customHooks/useDelete';

const truncateText = (text, maxLength) => {
  if (!text) {
    return '';
  }

  if (text.length <= maxLength) {
    return text;
  }

  return `${text.slice(0, maxLength)}...`;
};

const isVideoUrl = (url = '') => /\.(mp4|webm|ogg|mov)(\?|#|$)/i.test(url);

const canAccessMobileGuideAction = (permission, action) =>
  permission?.Guide?.includes(action) ||
  permission?.Guidance?.includes(action) ||
  permission?.MobileGuide?.includes(action);

const MobileGuideCard = ({ data, alldata, deleted, permission }) => {
  const { id, image, title, description, button_text, redirect_url, status } = data;
  const [resDelete, apiMethodDelete] = useDelete();

  const handleDelete = () => {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure that you want to delete?',
      buttons: true,
      icon: 'warning',
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        apiMethodDelete(`mobile/guide/${id}`);
      }
    });
  };

  useEffect(() => {
    if (resDelete.data) {
      const { message, status: deleteStatus } = resDelete.data;
      if (deleteStatus === 'false' || deleteStatus === false) {
        toast.error(message);
        return;
      }

      deleted(alldata.filter((item) => item.id !== id));
      toast.success(message ?? 'Mobile guide deleted successfully');
    }
  }, [alldata, deleted, id, resDelete.data]);

  useEffect(() => {
    if (resDelete.error) {
      toast.error(resDelete?.error?.response?.data?.message ?? 'Failed to delete mobile guide');
    }
  }, [resDelete.error]);

  return (
    <div className='BlogsCard group relative overflow-hidden rounded-[1.5rem] border border-[#D4DEF1] bg-white shadow-custom transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(18,38,63,0.10)]'>
      {canAccessMobileGuideAction(permission, 'Guide Delete') && (
        <div
          className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[2rem] h-[2rem] p-[.6rem] top-[.7rem] right-[.7rem] grid place-items-center rounded-[.7rem] z-10'
          onClick={handleDelete}
        >
          <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      )}

      <Link className="BlogsCardMain flex flex-col gap-4 p-4 lg:flex-row lg:items-center" to={`/mobile-guide/edit/${id}`}>
        <div className="BlogsCard__left w-full lg:w-[12rem] lg:flex-none">
          {image ? (
            isVideoUrl(image) ? (
              <video
                src={image}
                className='h-[11rem] w-full rounded-[1.25rem] bg-black object-cover lg:h-[8rem]'
                muted
                playsInline
                preload="metadata"
              />
            ) : (
              <img src={image} className='h-[11rem] w-full rounded-[1.25rem] object-cover lg:h-[8rem]' alt={title || 'mobile guide'} />
            )
          ) : (
            <div className='flex h-[11rem] w-full items-center justify-center rounded-[1.25rem] border border-dashed border-[#D4DEF1] bg-[#EFF4FD] text-sm text-[#7D8CA7] lg:h-[8rem]'>
              No Media
            </div>
          )}
        </div>

        <div className="BlogsCard__leftRight min-w-0 flex-1 lg:pr-4">
          <div className="mb-2 max-h-[3.1rem] overflow-hidden text-[1.1rem] capitalize font-MluvkaLight leading-[1.2] text-[#101828] lg:text-[1.25rem]">{title}</div>
          <div className='mb-3 max-h-[4.9rem] overflow-hidden text-[.88rem] leading-[1.65] text-[#475467]'>{truncateText(description, 140)}</div>
          <div className='text-[#7D8CA7] text-[.75rem] leading-[1.5] mb-1'>Button: {button_text || '-'}</div>
          <div className='text-[#7D8CA7] text-[.75rem] leading-[1.5] mb-1 break-all'>URL: {redirect_url || '-'}</div>
          <div className='text-[#7D8CA7] text-[.75rem] leading-[1.5]'>Status: {String(status) === '1' ? 'Active' : 'Inactive'}</div>
        </div>
        <div className="flex flex-row items-center justify-between gap-3 border-t border-[#EEF2F7] pt-4 lg:w-[10rem] lg:flex-col lg:items-end lg:justify-center lg:border-t-0 lg:pt-0 status-button">
          <span className="text-sm font-MluvkaBold text-[#0F172A]">Open</span>
          <span className="rounded-full bg-[#EFF4FD] px-4 py-2 text-sm font-MluvkaBold text-primary transition-colors group-hover:bg-primary group-hover:text-white">
            Edit
          </span>
        </div>
      </Link>
    </div>
  );
};

export default MobileGuideCard;
